<template>
  <div class="smart">
    <!-- banner部分 -->
    <div class="smart-banner clearfix">
      <div>
        <h2>智慧校园</h2>
        <h3>人脸识别安全通道闸机方案</h3>
      </div>
    </div>
    <!-- 方案概述 -->
    <div class="container clearfix">
      <div class="smart-title">方案概述</div>
      <div class="smart-overview">
        <div>
          <h2>人脸识别安全通道闸机方案</h2>
          <p>人脸识别门禁通道管理系统其目的是为了有效的控制人员的出入，并且记录所有出入的详细情 况，来实现出入口的方便、安全管理，包含发卡和人脸数据采集、出入授权、实时监控、出入查询 及打印报表等；控制机支持联网或脱机工作。</p>
        </div>
      </div>
    </div>
    <!-- 方案优势 -->
    <div class="container clearfix">
      <div class="smart-title">方案优势</div>
      <ul class="smart-strength clearfix">
        <li>
          <h2>数据存储</h2>
          <p>高速硬盘稳定运行，大容量存储，可保存约500 万条访客进出详细记录，并可扩展至更大存储容量</p>
        </li>
        <li>
          <h2>灵敏触摸</h2>
          <p>与当前主流手机采用相同的触摸技术，10点触 摸式电容触摸屏，高灵敏度，高精度触摸定位，提高操作效率</p>
        </li>
        <li>
          <h2>证件读取</h2>
          <p>可自动读取二代身份证芯片信息,辨别身份证真 伪，并存储身份信息,方便查询</p>
        </li>
        <li>
          <h2>证件扫描</h2>
          <p>可扫描身份证、驾照、军官证等各类证件，保存为图片信息以备查询</p>
        </li>
        <li>
          <h2>手工录入</h2>
          <p>自定义模式，可手工输入来访人员姓名，证件 号，手机号，车辆等信息，支持人工访客登记 及自助访客登记等两种模式，支持二代身份证、 驾驶证、通行证等多种登录方式</p>
        </li>
        <li>
          <h2>人脸识别关联</h2>
          <p>可通过在访客机上采集的人脸信息与所刷身份 证进行关联，记录访客信息，作为进出凭证</p>
        </li>
        <li>
          <h2>凭条打印</h2>
          <p>可打印包含来访者身份信息的二维码码识别凭 条（访客单），值勤人员可通过访客凭条获取访客信息。</p>
        </li>
        <li>
          <h2>现场拍照</h2>
          <p>配备摄像头,可对来访人员进行现场实时拍照， 作为来访登记的一种补充，并将照片保存供查询。</p>
        </li>
        <li>
          <h2>访客预约</h2>
          <p>可通过微信方式进行访前预约；也可通过电话 或内部网络可提前预约被访人，提前录入来访 人信息，省去相关环节，节约时间，提高效率。</p>
        </li>
      </ul>
    </div>
    <!-- 方案架构 -->
    <div class="container clearfix">
      <div class="smart-title">方案架构</div>
      <div class="smart-schema">
        <img src="../../../assets/img/smart/framework_Image.png" alt="" />
      </div>
    </div>
    <!-- 相关案例 -->
    <div class="container clearfix">
      <div class="smart-title">相关案例</div>
      <ul class="smart-use mb100">
        <li>
          <div>
            <h2>盐城生物工程高等职业学校</h2>
          </div>
        </li>
        <li>
          <div>
            <h2>盐城技师学院</h2>
          </div>
        </li>
        <li>
          <div>
            <h2>上海工商职业技术学院</h2>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Ssfacerecognition',
};
</script>
<style scoped>
.smart-banner {
  width: 100%;
  height: 594px;
  background: #000;
}
.smart-banner div {
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: url(../../../assets/img/smart/background_Image.png) no-repeat;
  background-size: cover;
}
.smart-banner h2 {
  margin-top: 182px;
  text-align: center;
  font-size: 100px;
  font-weight: bold;
  color: #fff;
}
.smart-banner h3 {
  text-align: center;
  font-size: 30px;
  font-weight: 400;
  color: #fff;
}
.smart-title {
  width: 100%;
  margin-top: 100px;
  margin-bottom: 100px;
  text-align: center;
  font-size: 60px;
  font-weight: bold;
  color: #000;
}
.smart-overview {
  width: 100%;
  height: 334px;
}
.smart-overview p {
  font-size: 18px;
  font-weight: 400;
  color: #666;
  text-indent: 2em;
  line-height: 1.8;
}
.smart-overview h2 {
  text-align: center;
  margin-bottom: 45px;
  font-size: 24px;
  font-weight: bold;
  color: #000;
}
.smart-strength {
  display: table;
  margin-right: -132px;
}
.smart-strength li {
  float: left;
  width: 366px;
  height: 160px;
  margin-right: 41px;
  margin-bottom: 50px;
}
.smart-strength li h2 {
  margin-bottom: 20px;
  font-size: 24px;
  font-weight: bold;
  color: #333;
}
.smart-strength li p {
  font-size: 18px;
  font-weight: 400;
  color: #333;
  line-height: 1.6;
}
.smart-param > li {
  width: 100%;
  height: 96px;
  margin-bottom: 110px;
}
.smart-param li li {
  width: 25%;
  float: left;
}
.smart-param li .fl {
  width: 96px;
  height: 96px;
}
.smart-param li .fl img {
  width: 100%;
  height: 100%;
}
.smart-param li .fr {
  padding: 10px 20px;
  width: 64%;
}
.smart-param li .fr h2 {
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: bold;
  color: #333;
}
.smart-use {
  display: table;
  margin-right: -45px;
}
.smart-use li {
  position: relative;
  float: left;
  width: 370px;
  height: 296px;
  margin-right: 45px;
  background: #000;
  border-radius: 10px;
}
.smart-use li div {
  position: absolute;
  width: 100%;
  height: 100%;
}
.smart-use li:nth-child(1) > div {
  background: url(../../../assets/img/case/campus_Image_a.png);
}
.smart-use li:nth-child(2) > div {
  background: url(../../../assets/img/case/campus_Image_b.png);
}
.smart-use li:nth-child(3) > div {
  background: url(../../../assets/img/case/campus_Image_c.png);
}
.smart-use li div h2 {
  margin-top: 260px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: #fff;
}
</style>
